function RadioGroup() {
    return {
        value: false,
        init() {
            this.value = this.$el.querySelector('input[type=radio]:checked').value
        },
    }
}
window.RadioGroup = RadioGroup;